// extracted by mini-css-extract-plugin
export default {"response-section":"components-hotel-reviews-review-detail-review-detail-module__response-section"};